import React, { useState, useEffect } from 'react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import styled from 'styled-components';

interface RenderOrganizationLogoProps {
  logo: string | undefined | null;
  containerSize?: number;
  className?: string;
}

const LogoContainer = styled.div<{ containerSize: number }>`
  width: ${({ containerSize }) => containerSize}px;
  height: ${({ containerSize }) => containerSize}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: ${COLORS.whiteBase};
  border: 1px solid ${COLORS.grayLight};
  border-radius: 4px;
  overflow: hidden;
`;

const StyledLogo = styled.div<{
  logo: string;
  isWide: boolean;
  containerSize: number;
}>`
  background-image: url(${({ logo }) => logo});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${COLORS.whiteBase};
  width: ${({ isWide, containerSize }) =>
    isWide ? '100%' : `${containerSize - 10}px`};
  height: ${({ isWide, containerSize }) =>
    isWide ? 'auto' : `${containerSize - 10}px`};
  max-width: 100%;
  max-height: 100%;
  aspect-ratio: ${({ isWide }) => (isWide ? 'auto 16/9' : '1/1')};
`;

const RenderOrganizationLogo: React.FC<RenderOrganizationLogoProps> = ({
  logo,
  containerSize = 60,
  className,
}) => {
  const [isWide, setIsWide] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!logo) return;

    const img = new Image();
    img.onload = () => {
      // Consider an image wide if width is more than 1.5x height
      setIsWide(img.width > img.height * 1.5);
      setIsLoaded(true);
    };
    img.src = logo;
  }, [logo]);

  if (!logo) return null;

  return (
    <LogoContainer className={className} containerSize={containerSize}>
      <StyledLogo logo={logo} isWide={isWide} containerSize={containerSize} />
    </LogoContainer>
  );
};

export default RenderOrganizationLogo;
